import { Chip, Link, Stack } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { navigate } from "lib/routes/navigate"
import { useContext } from "react"
import { OkCancelContext } from "lib/@hooks/useDialog"
import { GroupType } from "../../../../../lib/enum/group-type.js"
import { getGroupTypeLabel } from "../../../../../lib/get-group-type-label"

export function UnappliedGroupLink({ group, projectId }) {
    const { id, name, type } = group
    const { cancel } = useContext(OkCancelContext)
    const icon = type === GroupType.ADD ? "ic:round-post-add" : "ic:round-find-replace"

    return (
        <Stack direction="row" alignItems="center" spacing={1} sx={{ py: 0.5 }}>
            <Iconify icon={icon} sx={{ width: 20, height: 20, color: "text.secondary" }} />
            <Link
                component="button"
                variant="body2"
                onClick={handleNavigate}
                sx={{ textAlign: "left" }}
                data-cy={`unapplied-group-link-${id}`}
            >
                {name}
            </Link>
            <Chip label={getGroupTypeLabel(type)} size="small" variant="outlined" />
        </Stack>
    )

    function handleNavigate() {
        cancel?.()
        navigate(`/authoring/projects/${projectId}/${id}`)
    }
}
